module.exports = __webpack_public_path__ + "img/2010 winteressen 001.b9f1748b.jpg";